/* eslint-disable no-use-before-define */
import { cleanObject, fmt, arrayFrom, parseDate } from '../twd/twd'

export const fixParams = (accounts, filters, pageNumber=1, resultsPerPage=10) => {

    const searchParams = toSearchParams(accounts, filters)

    return {
        "tradeRow": cleanObject({
            "tradeStatus":[],
            "type":"traderow",
            ...searchParams,
        }),
        "sort": [{"field":"tradeSubmitDate","direction":"DESC"}],
        pageNumber,
        resultsPerPage,
        "excludeBlockOrders": true,
        "tradeSource": "ATSSOURCE",
    }
}


const toSearchParams = (accounts=[], filters={}) => {
    const minDt = parseDate(filters.tradeSubmitDateRangeMin)
    const maxDt = parseDate(filters.tradeSubmitDateRangeMax, true)
    const tradeSubmitDateRange = [
        fmt.mdy(minDt),
        fmt.mdy(maxDt)
    ].join(',')

    return cleanObject({
        acctNo: arrayFrom(accounts),

        tradeSubmitDateRange,

        holdInvType: arrayFrom(filters.holdInvType).filter(Boolean),
        holdCusip: (filters.holdCusip || '').split(',').map(a => a.trim()).filter(Boolean),

        tradeType: arrayFrom(filters.tradeType).filter(Boolean),
        tradeStatus: arrayFrom(filters.tradeStatus).filter(Boolean),

        type:"traderow",
    })
}